import { useWizard } from "react-use-wizard";
import { Button } from "../Actions";
import cx from "classnames";
import { StepProps } from "./Metamask/MetamaskCreate";
import { FlowStates } from "../../pages/novice";

const Footer: React.FC<
  StepProps & {
    hideFooterOnLastStep?: boolean;
    currentState: FlowStates;
  }
> = ({ hideFooterOnLastStep, prevState, setFlowState, currentState }) => {
  const { nextStep, previousStep, isFirstStep, isLastStep } = useWizard();
  const className = cx(
    "flex flex-row gap-2 p-4 py-8 justify-between max-w-2xl mx-auto border-t-2 mt-auto",
    { hidden: hideFooterOnLastStep && isLastStep }
  );

  const FinalStepAction = () =>
    setFlowState({ prev: currentState, current: "success" });
  return (
    <div className="fixed bottom-0 right-0 left-0 bg-coinage-light">
      <footer className={className}>
        <Button
          modifier="secondary"
          analyticsProperty="footer back"
          onClick={previousStep}
          disabled={isFirstStep}>
          Back
        </Button>
        <Button
          modifier="primary"
          analyticsProperty="footer next"
          onClick={isLastStep ? FinalStepAction : nextStep}>
          Next
        </Button>
      </footer>
    </div>
  );
};

export default Footer;
